export const Constants = {
    formatSeparator: "_",
    twoDigitYearMax: 68,
    defaultDateFormat: "d",
    defaultLocaleId: "en"
};
